var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLogout = function SvgIconLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-62)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M73,15h2v5a2,2,0,0,1-2,2H66a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2V9H73V4H66V20h7Zm10.923-2.618a1,1,0,0,0-.217-1.09l-4-4a1,1,0,0,0-1.414,1.414L80.586,11H70a1,1,0,0,0,0,2H80.586l-2.293,2.293a1,1,0,1,0,1.414,1.414l4-4A1,1,0,0,0,83.923,12.382Z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-logout.b82627b2.svg";
export { ForwardRef as ReactComponent };